import { useState } from 'react';
import { LocalBackupPanel } from './LocalBackupPanel';

export function LocalStateRecovery({ problem, original, pending, onRetry, onReload, onReset }: {
  problem: 'corrupt' | 'read' | 'write' | 'conflict';
  original: string | null;
  pending: string | null;
  onRetry(): void;
  onReload(): void;
  onReset(): void;
}) {
  const [notice, setNotice] = useState('');
  const exportText = (text: string, filename: string) => {
    try {
      const url = URL.createObjectURL(new Blob([text], { type: 'application/json;charset=utf-8' }));
      const anchor = document.createElement('a');
      anchor.href = url;
      anchor.download = filename;
      anchor.click();
      setTimeout(() => URL.revokeObjectURL(url), 1000);
      setNotice('파일 다운로드를 요청했어요. 파일이 보이지 않으면 아래 원문을 직접 복사해 보관해 주세요.');
    } catch { setNotice('이 환경에서는 파일을 내려받지 못했어요. 아래 원문을 직접 복사해 보관해 주세요.'); }
  };
  return <section className="card stack local-state-recovery" aria-labelledby="recovery-title">
    <div role="alert">
      <h2 id="recovery-title">{problem === 'corrupt' ? '저장된 좌석 기록을 읽지 못했어요' : problem === 'read' ? '이 기기의 저장 공간을 열지 못했어요' : problem === 'conflict' ? '다른 화면에서 저장한 기록이 있어요' : '변경 내용을 이 기기에 저장하지 못했어요'}</h2>
      <p>{problem === 'corrupt' ? '원본은 그대로 두었어요. 원문을 보관한 뒤 다시 읽거나, 이 기기의 좌석 기록만 초기화할 수 있어요.' : problem === 'read' ? '저장된 내용이 있는지 확인할 수 없어 새 기록으로 덮어쓰지 않아요. 저장 공간 접근을 허용한 뒤 다시 시도해 주세요.' : '현재 화면의 내용은 아직 이 화면에만 있어요. 화면을 닫거나 새로고침하면 잃을 수 있으니 내용을 보관하고 다시 시도해 주세요.'}</p>
    </div>
    <div className="inline">
      {problem !== 'conflict' ? <button type="button" className="button button-primary" onClick={onRetry}>{pending === null ? '저장된 기록 다시 읽기' : '현재 내용 저장 재시도'}</button> : <button type="button" className="button" onClick={() => { if (window.confirm('현재 화면의 미저장 내용을 보관했나요? 다른 화면에서 저장한 기록을 불러오면 이 화면의 변경 내용은 사라져요.')) onReload(); }}>저장된 기록 다시 불러오기</button>}
      {original !== null ? <button type="button" className="button" onClick={() => exportText(original, 'anjabom-original.json')}>기존 원본 내려받기</button> : null}
      {pending !== null ? <button type="button" className="button" onClick={() => exportText(pending, 'anjabom-unsaved.json')}>미저장 내용 내려받기</button> : null}
    </div>
    <details>
      <summary>파일을 받기 어려우면 원문 복사하기</summary>
      <p className="micro">개인 메모가 포함될 수 있어요. 공개된 곳에 올리지 말고 개인 보관 공간에 저장해 주세요.</p>
      {original !== null ? <label className="field">기존 원본<textarea aria-label="기존 원본" className="textarea" readOnly rows={4} value={original} onFocus={(event) => event.currentTarget.select()} /></label> : <p>기존 원본을 읽지 못해 표시할 수 없어요.</p>}
      {pending !== null ? <label className="field">미저장 내용<textarea aria-label="미저장 내용" className="textarea" readOnly rows={4} value={pending} onFocus={(event) => event.currentTarget.select()} /></label> : null}
    </details>
    {notice ? <p role="status">{notice}</p> : null}
    {pending === null ? <LocalBackupPanel /> : null}
    {problem === 'corrupt' ? <details><summary>원본 보관 후 새로 시작하기</summary><p>이 기기의 좌석 후보·관람 계획·좌석 결정을 비워요. 계정의 서버 기록과 관람 사진은 삭제하지 않아요.</p><button type="button" className="button button-danger" onClick={onReset}>이 기기의 좌석 기록 초기화</button></details> : null}
  </section>;
}
